<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="2"></dialogos-app>
            </v-flex>
        </v-layout>
        <!-- subcont 1 -->
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeInUp" v-show="contPage == 1">
          <v-flex xs12 sm7 md7>
            <h2 class="bold-blue fz-20">Formais</h2>
            <!-- dropables -->
            <div v-for="(dropItem, index) in dropList" :key="'item'+index">
              <h2 class="titulos">{{titulos[index]}}</h2>
              <draggable v-model="dropList[index]" @change="change($event, index , correctas, dropList, dragList, retroaliment)" 
              :options="{group:{ name:'itemsgroup', put:retroaliment[index]}}" class="cont-drop"> 
                <p  v-for="element in dropList[index]" :key="element"><span v-html="element"></span></p>
              </draggable>
            </div>
          </v-flex>
          <v-flex xs10 mt-3>
            <!-- <v-card flat tile color="transparent"  class="cont-drags"> -->
              <!-- <v-card-actions class="cont-btn-nextprev" reverse>
                <div class="hvr btn-slide-prev" fab small @click="prev">
                  <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
                </div>
                <div class="hvr btn-slide-next" fab small @click="next">
                  <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
                </div>
              </v-card-actions> -->
              <!-- <v-window v-model="onboarding"> -->
                <!-- draggables -->
                <draggable v-model="dragList" @start="saveEl" class="drag-container" :options="{group:'itemsgroup'}">
                  <div v-for="element in dragList" :key="element">
                    <div class="btn-blue-dark btn-drag hvr" :class="'animated bounceIn dura-'+element+''">
                      <span v-html="element"></span>
                    </div>
                  </div>
                </draggable>
              <!-- </v-window>
            </v-card> -->
          </v-flex>
        </v-layout>
        <!-- subcont 2 -->
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page animated fadeInUp" v-show="contPage == 2">
          <v-flex xs12 sm7 md7>
            <h2 class="bold-blue fz-20">Informais</h2>
            <!-- dropables -->
            <div v-for="(dropItem, index) in dropListB" :key="'item'+index">
              <h2 class="titulos">{{titulos[index]}}</h2>
              <draggable v-model="dropListB[index]" @change="change($event, index, correctasB , dropListB , dragListB ,retroalimentB)" 
              :options="{group:{ name:'itemsgroup', put:retroalimentB[index]}}"  class="cont-drop">
                <p  v-for="element in dropListB[index]" :key="element"><span v-html="element"></span></p>
              </draggable>
            </div>
          </v-flex>
          <v-flex xs10 mt-3 v-if="ocultarBotones">
            <!-- <v-card flat tile color="transparent"> -->
              <!-- <v-card-actions class="cont-btn-nextprev" reverse>
                <div class="hvr btn-slide-prev" fab small @click="prevB">
                  <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
                </div>
                <div class="hvr btn-slide-next" fab small @click="nextB">
                  <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
                </div>
              </v-card-actions> -->
              <!-- <v-window v-model="onboardingB"> -->
                <!-- draggables -->
                <draggable v-model="dragListB" @start="saveEl" class="drag-container" :options="{group:'itemsgroup'}">
                  <div v-for="element in dragListB" :key="element">
                    <div class="btn-blue-dark btn-drag hvr" :class="'animated bounceIn dura-'+element+''">
                      <span v-html="element"></span>
                    </div>
                  </div>
                </draggable>
              <!-- </v-window>
            </v-card> -->
          </v-flex>
        </v-layout>
      <modal-resultado-app v-model="modalResultado" :nameResult="modalResult" @bienAvanzar="bienAction()">
      </modal-resultado-app>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
export default {
  mixins: [nextConditions],
  components: {
			draggable
  },
  data() {
    return {
      dialogos: [
        'Coloque as expressões abaixo no lugar adequado.'
      ],
      length: 3,
      lengthB: 3,
      onboarding: 0,
      onboardingB: 0,
      dragList:[
        'Senhora Morales, como vai?',
        'Este é Raul, um amigo da escola.',
        'Até logo.',
      ],
      dragListB:[
        'O prazer é todo meu.',
        'Tudo legal!',
        'A gente se fala.',
      ],
      correctas:[
        'Senhora Morales, como vai?',
        'Até logo.',
        'Este é Raul, um amigo da escola.'
      ],
      correctasB:[
        'Tudo legal!',
        'A gente se fala.',
        'O prazer é todo meu.',
      ],
      dropList:Array(3).fill([]),
      retroaliment:Array(3).fill(true),
      retroalimentB:Array(3).fill(true),
      dropListB:Array(3).fill([]),
      titulos:['Cumprimento','Despedida','Apresentação'],
      modalResultado:false,
      correctos:0,
      contPage:1,
      ocultarBotones:true,
      
    }
  },
  methods: {
      next() {
        this.onboarding = this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
      },
      prev() {this.onboarding = this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
      },
      nextB() {
        this.onboardingB = this.onboardingB + 1 === this.lengthB ? 0 : this.onboardingB + 1
      },
      prevB() {this.onboardingB = this.onboardingB - 1 < 0 ? this.lengthB - 1 : this.onboardingB - 1
      },
      saveEl(ev) {
        console.log('start ' + ev.item.innerHTML)
      },
      change(ev, slotNum, arrayCorrectas, arrayDrop, arrayDrag, retro) {
        console.log('changed ' + ev, slotNum, arrayCorrectas)
        console.log(slotNum)
        if(arrayDrop[slotNum] == arrayCorrectas[slotNum]){
          this.modalResultado = true
          this.modalResult = 'bien'
          this.$set(retro,slotNum,false)
          this.next()
          this.nextB()
        }else {
          this.modalResultado = true
          this.modalResult = 'mal'
          this.$set(arrayDrop,slotNum,'')
          arrayDrag.push(ev.added.element)
          this.prev()
          this.prevB()
        }
      },
      bienAction(){
        this.correctos += 1
        if(this.correctos == 3){
          setTimeout(() => {
          this.contPage = 2
          this.nextB()
          }, 1000);
        }else if(this.correctos == 6){
          this.ocultarBotones = false
          this.$store.commit('nextShow', true);
        }
      }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';

.cont-drop{
  border: 2px solid $ibra-blue;
  margin: 1px 30px;
  padding: 10px;
  p{
    margin: 0;
    padding: 0;
    font-family: Poppins-Regular;
    font-size: 12px;
  }
}
.titulos{
  margin: 0;
  padding: 0;
  font-family: Poppins-Regular;
  font-size: 12px;
  margin-top: 2px;
  color: $ibra-dark-blue;
}
.drop-correcto{
  background: $ibra-green;
}
.drop-incorrecto{
  background: $ibra-orange;
}
.drag-container{
  width: 100%;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
}
.btn-drag{
  width: 130px;
  margin: 2px;
  padding: 3px 2px;
  text-align: center;
  font-size: 14px;
  line-height: 18px;
}
// .btn-drag{
//   width: 120px;
//   margin: 0 auto;
//   padding: 2px;

// }
.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  padding: 12px;
  top: 35%;
  .btn-slide-next{
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
    z-index: 2;
  }
}
.cont-drags{
  position: relative;
}
</style>
